import { usePseudoClasses } from "./usePseudoClasses.js";
const useHover = (ref) => {
  const { refObject, isHovered, isFocused } = usePseudoClasses(ref);
  return { hoverRef: refObject, isHovered: isHovered || isFocused };
};
export {
  useHover
};
//# sourceMappingURL=useHover.js.map
